export const CREATE_CUSTOMER_VEHICLE_MAP = 'CREATE_CUSTOMER_VEHICLE_MAP';
export const EDIT_CUSTOMER_VEHICLE_MAP = 'EDIT_CUSTOMER_VEHICLE_MAP';
export const SHOW_CUSTOMER_VEHICLE_MAP = 'SHOW_CUSTOMER_VEHICLE_MAP';
export const CUSTOMER_VEHICLE_MAP_SUCCESS = 'CUSTOMER_VEHICLE_MAP_SUCCESS';
export const CUSTOMER_VEHICLE_MAP_ERROR = 'CUSTOMER_VEHICLE_MAP_ERROR';

